import {
  HTTP_UPDATEFORECASTLIST_FETCHING,
  HTTP_UPDATEFORECASTLIST_SUCCESS,
  HTTP_UPDATEFORECASTLIST_FAILED,
  server,
} from "./../../Constants";
import Axios from "axios";
import { httpClient } from "./../../utils/HttpClient";

//insert Budgets
export const setStateUpdateForecastToFetching = () => ({
  type: HTTP_UPDATEFORECASTLIST_FETCHING,
});

export const setStateUpdateForecastToSuccess = (payload) => ({
  type: HTTP_UPDATEFORECASTLIST_SUCCESS,
  payload,
});

export const setStateUpdateForecastToFailed = (payload) => ({
  type: HTTP_UPDATEFORECASTLIST_FAILED,
});

export const updateForecast = (item) => {
  return async (dispatch) => {
    dispatch(setStateUpdateForecastToFetching());
    try {
      await httpClient.post(`${server.UPDATEFORECAST_URL}`, item);
      dispatch(setStateUpdateForecastToSuccess("success"));
    } catch (error) {
      dispatch(setStateUpdateForecastToFailed());
    }
  };
};
